import React from 'react';
import { NavLink } from "react-router-dom";
import cn from 'classnames'

const NavBar = (props) => {
  const { className, setMenuIsOpen } = props;

  return (
    <ul className={cn('nav nav-pills nav-stacked', className)}>
      {
        props.tabs.map((tab) => {
          return (
						<li className='nav-item' key={`nav-${tab.eventKey}`}>
							<NavLink
								onClick={() => {
								  setMenuIsOpen && setMenuIsOpen(false);
								}}
								to={tab.eventKey}
								activeClassName='active'
								className='nav-link'>
								{tab.name}
							</NavLink>
						</li>
					);
        })
      }
    </ul>
  );
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/navBar.js